import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Te rechazaron un préstamo', 'No pudiste financiar una moto', 'Te negaron una tarjeta', 'No sabes qué información aparece sobre ti', 'Sientes incertidumbre sobre tu situación financiera', 'Nadie te explica claramente cuáles son tus derechos'];
  return <section className="py-16 md:py-24 px-4 bg-surface-gray" data-id="element-254">
      <div className="max-w-4xl mx-auto" data-id="element-255">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-256">
          <h2 className="text-3xl md:text-4xl font-black text-slate-dark mb-6" data-id="element-257">
            Quizás te pasó alguna de estas situaciones...
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-258">
          {problems.map((problem, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-4 rounded-xl border border-gray-100 shadow-sm flex items-start gap-3" data-id="element-259">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-260" />
              <p className="text-slate font-medium" data-id="element-261">{problem}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-white p-6 rounded-2xl border border-red-100 shadow-sm" data-id="element-262">
          <p className="text-lg md:text-xl font-bold text-slate-dark" data-id="element-263">
            La falta de información genera frustración, incertidumbre y
            decisiones equivocadas.
          </p>
        </motion.div>
      </div>
    </section>;
}